import { Modal } from 'antd';

interface ConfirmCloseProps {
    hasChanges: boolean;
    onConfirm: () => void;
    title?: string;
    content?: string;
}

export const confirmCloseModal = ({ hasChanges, onConfirm, title = 'Xác nhận', content = 'Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn đóng?' }: ConfirmCloseProps) => {
    if (hasChanges) {
        Modal.confirm({
            title,
            content,
            okText: 'Đóng',
            cancelText: 'Hủy',
            onOk: onConfirm
        });
    } else {
        onConfirm();
    }
}; 